import { NgRedux, select } from '@angular-redux/store';
import { Component } from '@angular/core';
import { SidenavService } from '../../services/sidenav.service';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { AuthDispatcher } from '../../../store/auth/auth-dispatcher';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { Observable, Subscription } from 'rxjs';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { AppState } from '../../../store/state.model';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { SnackBarService } from '../../../common/services/snack-bar/snack-bar.service';
import { MatButton, MatAnchor } from '@angular/material/button';
import { NgIf, NgFor, KeyValuePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    imports: [MatButton, NgIf, NgFor, MatAnchor, MatIcon, TranslatePipe, KeyValuePipe]
})
export class UserProfileComponent {
  /**
  * @property Property to store the user profile settings api response
  */
  public userProfileSettings: any;
  /**
  * @property Property to store the api subscription
  */
  public apiSubscription: Subscription;
  /**
  * @property Property to store the user profile settings object
  */
  public userProfileSettingsObject: any[];
  /**
  * @property Property to store the user profile details to render on the UI
  */
  public userProfileDetails: string;
  /**
  *@arg apiObservable   observe api variable in redux
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
  * @property Property to check whether user profiles data found or not
  */
  public userProfilesSettingsDataExists: boolean;

  constructor(
    private sidenav: SidenavService,
    public orch: OrchestrationService,
    public authDispatcher: AuthDispatcher,
    public reduxState: NgRedux<AppState>,
    public translate: TranslationService,
    private snackBarService: SnackBarService,
  ) {
    this.getUserProfileSettings();
    this.apiSubscription = this.apiObservable.subscribe((api) => {
      if (api.apiAction === ApiResponseActions.SET_21MM_USER_PROFILE_SETTINGS) {
        if (api.apiResponse['type'] === 'success') {
          this.userProfileSettings = api.apiResponse['payload']['user_profile'];
          this.setupUserProfileData();
        } else {
          this.snackBarService.showToast(this.translate.getCustomTranslation('errors.error-ocurred')['value']);
        }
      }
    });
  }

  /**
  * @function setupUserProfileData sets the data to render on UI
  **/
  public setupUserProfileData() {
    this.userProfileSettingsObject = [];
    for (const prop in this.userProfileSettings) {
      if (this.userProfileSettings.hasOwnProperty(prop)) {
        const innerObj = {};
        innerObj[prop] = this.userProfileSettings[prop];
        this.userProfileSettingsObject.push(innerObj);
      }
    }
    this.userProfileSettingsObject.forEach(element => {
      element['isExpanded'] = false;
    });
  }

  /**
  * @function getUserProfileSettings calls the getUserProfileSettings end point
  **/
  public getUserProfileSettings() {
    const userGuid = this.reduxState.getState().customer['data']['guid'];
    const vehicleInfo = this.reduxState.getState().selectedVehicle.vehicle;

    if (!!userGuid) {
      this.orch.get21MMUserProfileSettings(vehicleInfo);
      this.userProfilesSettingsDataExists = true;
    } else {
      this.userProfilesSettingsDataExists = false;
    }
  }

  /**
  * @function close closes the side nav when called
  **/
  public close(): void {
    this.sidenav.close();
  }

  /**
  * @function viewUserProfileSettings views the user profile settings
  **/
  public viewUserProfileSettings(selectedElement): void {
    selectedElement.isExpanded = !selectedElement.isExpanded;
    this.userProfileDetails = JSON.stringify(selectedElement, undefined, 3);
    this.userProfileSettingsObject.forEach(element => {
      if (JSON.stringify(selectedElement) != JSON.stringify(element)) {
        element['isExpanded'] = false;
      }
    });
  }

  /**
  * @function translateParams translates the string
  **/
  public translateParams(param): string {
    return 'user-profile.labels.' + param;
  }
}
